import DocumentTitle from '@/components/ui/DocumentTitle'
import RouterLink from '@/components/ui/RouterLink'

// Mantine
import { Anchor } from '@mantine/core'

// Icons
import { IconHome, IconChevronRight, IconSlash } from '@tabler/icons-react'

export default function Breadcrumbs({
    breadcrumbs = [],
    rightSection,
    noTopMargin = false,
}) {
    const lastBreadcrumb = breadcrumbs[breadcrumbs.length - 1]

    return (
        <>
            {breadcrumbs.length > 0 && (
                <DocumentTitle title={'BO - ' +
                            [...breadcrumbs]
                                .reverse()
                                .map((breadcrumb) => breadcrumb.label)
                                .join(' / ') +
                            ' - Baltic Watches'} />
            )}

            <div className={`${noTopMargin ? '' : 'mt-3'} px-5 shrink flex justify-between items-center gap-5`}>
                {lastBreadcrumb && (
                    <span className="text-black truncate md:hidden">
                        {lastBreadcrumb.label}
                    </span>
                )}

                <div className="gap-2 items-center truncate shrink hidden md:flex">
                    <Anchor c="gray" component={RouterLink} href="/">Dashboard</Anchor>

                    {breadcrumbs.map((breadcrumb, index) => {
                        return (
                            <div
                                className="flex items-center gap-2 truncate"
                                key={index}
                            >
                                <IconSlash
                                    className="text-gray-400 shrink-0"
                                    size={16}
                                />

                                {breadcrumb.href && (
                                    <Anchor
                                        c="gray"
                                        className="truncate"
                                        href={breadcrumb.href}
                                    >
                                        {breadcrumb.label}
                                    </Anchor>
                                )}

                                {!breadcrumb.href && (
                                    <span className="text-black truncate">
                                        {breadcrumb.label}
                                    </span>
                                )}
                            </div>
                        )
                    })}
                </div>

                <div className="flex items-center gap-2 h-[34px] shrink-0">
                    <div className="grow flex items-center gap-2 justify-end">
                        {rightSection}
                    </div>
                </div>
            </div>
        </>
    )

    return (
        <>
            {breadcrumbs.length > 0 && (
                <DocumentTitle title={'BO - ' +
                            [...breadcrumbs]
                                .reverse()
                                .map((breadcrumb) => breadcrumb.label)
                                .join(' / ') +
                            ' - Baltic Watches'} />
            )}

            <div className="w-full h-[60px] bg-white @container border-b text-gray-500 flex justify-between p-5 gap-1">
                <div className="gap-4 text-lg hidden @2xl:flex">
                    <Link to="/" className="flex items-center gap-1">
                        <IconHome size={22} />
                    </Link>

                    {breadcrumbs.map((breadcrumb, index) => {
                        return (
                            <div
                                className="flex items-center gap-4"
                                key={index}
                            >
                                <IconChevronRight
                                    className="opacity-50"
                                    size={16}
                                />

                                {breadcrumb.href && (
                                    <Link to={breadcrumb.href}>
                                        {breadcrumb.label}
                                    </Link>
                                )}

                                {!breadcrumb.href && (
                                    <span className="text-black">
                                        {breadcrumb.label}
                                    </span>
                                )}
                            </div>
                        )
                    })}
                </div>

                <div className="gap-4 text-lg flex @2xl:hidden">
                    <Link to="/" className="flex items-center gap-1">
                        <IconHome size={22} />
                    </Link>

                    <div className="flex items-center gap-4">
                        <IconChevronRight className="opacity-50" size={16} />

                        {lastBreadcrumb.href && (
                            <Link to={lastBreadcrumb.href}>
                                {lastBreadcrumb.label}
                            </Link>
                        )}

                        {!lastBreadcrumb.href && (
                            <span className="text-black">
                                {lastBreadcrumb.label}
                            </span>
                        )}
                    </div>
                </div>

                <div className="flex items-center gap-5">
                    <div className="grow flex items-center gap-2 justify-end">
                        {rightSection}
                    </div>
                </div>
            </div>
        </>
    )
}
